import { render, staticRenderFns } from "./pagingCompont.vue?vue&type=template&id=28e8bdf5&scoped=true"
import script from "./pagingCompont.vue?vue&type=script&lang=js"
export * from "./pagingCompont.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8bdf5",
  null
  
)

export default component.exports